import TeamsHome from "./home";


const currentPath = document.body.getAttribute("data-current-path");
if (currentPath && currentPath === "teams/home") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new TeamsHome();
    }
}
